import React from 'react';
import { IPushNotificationsContext } from './types';
import { PUSH_NOTIFICATIONS_DEFAULT_STATUS } from './const';

const mock = () => {
  throw new Error('Push notitications context is not set');
};

export const PushNotificationsContext = React.createContext<IPushNotificationsContext>({
  manager: {
    subscribe: mock,
    checkSubscription: mock,
    status: PUSH_NOTIFICATIONS_DEFAULT_STATUS,
    subscription: undefined,
    addEventListener: mock,
    removeEventListener: mock,
  },
  status: PUSH_NOTIFICATIONS_DEFAULT_STATUS,
});

export const usePushNotifications = () => React.useContext(PushNotificationsContext);
